var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBluePolygon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 11L3.14953 12.8388L1.08678 15.8962L4.70494 16.1467L4.14019 19.8203L7.50734 18.4415L8.55274 22L11 19.2562L13.4473 22L14.4927 18.4415L17.8585 19.8203L17.2951 16.1467L20.9119 15.8962L18.8505 12.8388L22 11L18.8505 9.16119L20.9119 6.10381L17.2951 5.85325L17.8585 2.1811L14.4927 3.55987L13.4473 0L11 2.74384L8.55274 0L7.50734 3.55987L4.14019 2.1811L4.70494 5.85325L1.08678 6.10381L3.14953 9.16119L0 11Z",
    fill: "#115EF3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBluePolygon);
export default __webpack_public_path__ + "static/media/blue-polygon.8d648a6d7a55a63083baeb5c1e19ad21.svg";
export { ForwardRef as ReactComponent };